export const getTaskLeadRedirectPath = (params: {
  userId?: string | number | null;
  leadId?: string | number | null;
}): string | null => {
  const userId =
    params.userId != null && String(params.userId).trim() !== ''
      ? String(params.userId).trim()
      : null;

  if (userId) {
    return `/users/${userId}`;
  }

  const leadId =
    params.leadId != null && String(params.leadId).trim() !== ''
      ? String(params.leadId).trim()
      : null;

  if (leadId) {
    return `/leads?view=${encodeURIComponent(leadId)}`;
  }

  return null;
};
